export default {
  idleTime: 1000 * 60 * 10, // time in ms, for example: 100 * 60 * 10 = 10 minutes
};
